import "./ui.scss";
import UiAvatar from "./UiAvatar.vue";
import UiBanner from "./UiBanner.vue";
import UiButton from "./UiButton.vue";
import UiCheck from "./UiCheck.vue";
import UiChip from "./UiChip.vue";
import UiChips from "./UiChips.vue";
import UiConfirm from "./UiConfirm.vue";
import UiField from "./UiField.vue";
import UiFilterBar from "./UiFilterBar.vue";
import UiIconButton from "./UiIconButton.vue";
import UiItem from "./UiItem.vue";
import UiKpis from "./UiKpis.vue";
import UiKv from "./UiKv.vue";
import UiPopover from "./UiPopover.vue";
import UiSearch from "./UiSearch.vue";
import UiSection from "./UiSection.vue";
import UiSegment from "./UiSegment.vue";
import UiSheet from "./UiSheet.vue";
import UiState from "./UiState.vue";
import UiStat from "./UiStat.vue";
import UiSwitch from "./UiSwitch.vue";
import UiTable from "./UiTable.vue";
import UiToast from "./UiToast.vue";
import UiToggle from "./UiToggle.vue";

/**
 * Zajedničke komponente novog izgleda (<ui-button>, <ui-chip>, <ui-table>...). Registruju se globalno u main.js sa Vue.use(UiKit),
 * pa se u šablonima koriste bez uvoza. Stilovi su u ui.scss i važe unutar korijena ljuske (.rd), gdje su tokeni boja.
 */
const components = {
  UiAvatar,
  UiBanner,
  UiButton,
  UiCheck,
  UiChip,
  UiChips,
  UiConfirm,
  UiField,
  UiFilterBar,
  UiIconButton,
  UiItem,
  UiKpis,
  UiKv,
  UiPopover,
  UiSearch,
  UiSection,
  UiSegment,
  UiSheet,
  UiState,
  UiStat,
  UiSwitch,
  UiTable,
  UiToast,
  UiToggle,
};

export default {
  install(Vue) {
    Object.keys(components).forEach((name) => Vue.component(name, components[name]));
  },
};
